export default __webpack_public_path__ + "static/media/logo.ecb09118.svg";